import React from "react";
import { INTERACTIVE_BUTTON_TYPE, InteractiveButton } from "../components/InteractiveButton.jsx";
import { useInteractiveProductsSettings } from "../context/interactive-product-context.jsx";
import { SVG_HEART_MASK_IMAGE_BASE64 } from "../../interactive-images";
import { useProductFollow } from "../components/buttons/like-button/hooks/use-product-follow.js";
import { optionalTranslation } from "../../translations/translation-utils.js";

export const LightboxLikeButton = ({ followingRequestBody, productUid }) => {
	const { translations } = useInteractiveProductsSettings();

	const { following, isButtonDisabled, performFollowRequest, buttonTitle } =
		useProductFollow({
			productUid,
			followingRequestBody,
		});

	const likeButtonContent = optionalTranslation(
		translations["like.button.text"]
	);

	const innerContent = likeButtonContent ? (
		<p>{likeButtonContent}</p>
	) : undefined;

	return (
		<InteractiveButton
			colorful
			colorfulActive={following}
			onClick={performFollowRequest}
			disabled={isButtonDisabled}
			maskImageSrc={SVG_HEART_MASK_IMAGE_BASE64}
			innerContent={innerContent}
			buttonType={INTERACTIVE_BUTTON_TYPE.NORMAL_ROUND}
			additionalButtonWrapperClass="product-lightbox__bottom-button-common product-lightbox__bottom-button-like"
			title={buttonTitle}
		/>
	);
};
